<template>
  <section class="app__container overflow-hidden">
    <router-view />
  </section>
</template>

<script>
import { isMobileScreen } from '@/helpers/common';

export default {
  name: 'App',
  data() {
    return {
      isMobile: isMobileScreen(),
    };
  },
};
</script>

<style>
#app,
.app__container {
  min-height: 100vh;
  max-width: 100vw;
  background: #FFFFFF;
}
</style>
